import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from '../utils/toast';
import { useTranslation } from 'react-i18next';
import api from '../utils/api'; // Reuse your configured Axios instance
import { validatePassword, passwordStrength, translatedProblem } from '../utils/passwordPolicy';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const strength = passwordStrength(newPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      toast.error(t('messages.resetTokenMissing'));
      return;
    }

    const problem = validatePassword(newPassword);
    setPasswordError(problem || '');
    if (problem) {
      toast.error(translatedProblem(t, problem));
      return;
    }

    setLoading(true);
    try {
      const res = await api.post('/api/users/reset-password', {
        token,
        newPassword,
      });

      if (res.status === 200) {
        toast.success(t('messages.resetDone'));
        setTimeout(() => navigate('/login'), 1500);
      } else {
        toast.error(t('messages.resetFailed'));
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Server error during reset'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 bg-white shadow p-6 rounded">
      <h2 className="text-2xl mb-4 text-center">{t('auth.resetTitle')}</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="password"
          value={newPassword}
          onChange={(e) => { setNewPassword(e.target.value); setPasswordError(''); }}
          placeholder={t('auth.enterNewPassword')}
          className="border p-2 w-full rounded"
          autoComplete="new-password"
          required
        />
        {newPassword && (
          <p className="text-xs text-gray-600 -mt-2">
            {t('password.strength')}: <span className={`font-medium ${{ weak: 'text-red-600', medium: 'text-yellow-600', strong: 'text-green-600' }[strength]}`}>{t('password.' + strength)}</span>
          </p>
        )}
        <p className="text-xs text-gray-500 -mt-2">{t('password.guidance')}</p>
        {passwordError && <p role="alert" className="text-sm text-red-600">{passwordError}</p>}
        <button
          type="submit"
          disabled={loading}
          className="bg-green-600 text-white px-4 py-2 rounded w-full"
        >
          {loading ? t('auth.resetting') : t('reset.button')}
        </button>
      </form>
    </div>
  );
}
